
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import  LeftSection  from "./layout/LeftSection";
import  Portfolio  from "./Fund/Portfolio";
import  Wallethistory  from "./Fund/Wallethistory";
import  { WebContext }  from "../Webroute";
import  { currencySymbol } from "../functions/Function";

const  Fund = (props) => {
   const WebData = useContext(WebContext);
   const [isActive, setisActive] = useState('portfolio');
  
   

  useEffect(() => {
    WebData.fetchWallet()
   }, [])

  return (
    <>
            <section className="ivo-section funds">
               <div className="container">
                  <div className="funds-tabs ">
                     <div className="tabswithbutton">
                           <ul className="nav nav-tabs" id="myTab" role="tablist">
                              <li className="nav-item" role="presentation">
                                 <button
                                       className={isActive == 'portfolio' ? 'nav-link current active' : 'nav-link current'}
                                       onClick={()=>setisActive('portfolio')}
                                 
                                 >Portfolio </button>
                              </li>
                              <li className="nav-item" role="presentation">
                                 <button 
                                    className={isActive == 'wallethistory' ? 'nav-link current active' : 'nav-link current'}
                                    onClick={()=>setisActive('wallethistory')}
                                 
                                 >Wallet History</button>
                              </li>
                           </ul>
                           <div>
                           <Link to="/home/deposit" className="deposit-btn">Deposit {currencySymbol()}</Link>
                           </div>
                     </div>
                     

                     <div className="main-my-wallet-box">
                     <div className="my-wallet-box ">
                           <div className="wallet-heading">
                              <b>Total Amount <small><b>(Portfolio + Wallet)</b></small></b>
                           </div>
                           <h2>{currencySymbol()}{Number(WebData.totalAmount).toFixed(2) }</h2>
                           
                        </div>

                        <div className="my-wallet-box ">
                           <div className="wallet-heading">
                              <b>Total Portfolio Value</b>
                           </div>
                           <h2>{currencySymbol()}{Number(WebData.portfolioAmt).toFixed(2) }</h2>
                        </div>
                        <div className="my-wallet-box ">
                           <div className="wallet-heading">
                              <b>Wallet Amount</b>
                           </div>
                           <h2>{currencySymbol()}{ Number(WebData.wallet).toFixed(2)}</h2>
                        </div>
                     </div>


                     <div className="tab-content" id="myTabContent">
                     
                     {isActive == 'portfolio' && <Portfolio /> }
                     {isActive == 'wallethistory' && <Wallethistory /> }
                     </div>


                  </div>
               </div>
            </section>
    </>

  );
}

export default Fund;
